import {usePerformanceMonitoring} from '@app/hooks/usePerformanceMonitoring';

export const PerformanceMonitoring = () => {
	usePerformanceMonitoring();
	return null;
};
